<template>
  <div class="py-0" id="sidebar">
    <!-- <b-container-fluid> -->
    <ul>
      <li class="sidebar-logo-item">
        <div class="sidebar-logo-wrap" aria-hidden="true">
          <img :src="logoSrc" alt="logo" class="header-logo client-logo sidebar-logo" />
        </div>
      </li>
      <li
        v-for="(item, idx) in pages"
        :key="idx"
        :class="{ 'active-page': $route.name.toLowerCase() == item.route.toLowerCase() }" 
      >
        <a :href="item.ref"> 
          <i :class="`fa-solid fa-${resolveIcon(item)}`"></i> 
          <span>{{ item?.name }}</span> 
        </a>
      </li>
    </ul>
    <!-- </b-container-fluid> -->
  </div>
</template>

<script>
import Menu from '../../services/Menu'; 
import Authentication from "@/services/Authentication"

const imageContext = require.context("../../assets/imgs", false, /\.(png|jpe?g|svg)$/i);

export default {
  name: "Sidebar",
  data() {
    return {
      icono: "",
      compania : "",
      menu: "",
      home: "/#home",
      scroll: false,
      // rolPermiso: [1,2],
      listMenu: [],
      newMenu: []
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.scrollFunction); 
  },
  methods: {
    scrollFunction(e) {
      this.scroll = window.pageYOffset > 300; 
      e.preventDefault(); 
    },
    logout: function() {
      const obj = {
        token: "",
        username: "",
        role: "",
        expiresIn: "",
        isAuthenticated: false,
      };
      this.$store.commit("setData", obj); 
      this.$router.push("/"); 
    },
    toggleLanguage() {
      if (this.$store.state._language == "es-ES") { 
        this.$store.commit("setLang", "en-US"); 
      } else {
        this.$store.commit("setLang", "es-ES"); 
      }
    },
    resolveIcon(item) {
      const rawIcon = (item?.icon || "").toString().trim();
      if (!rawIcon) return "list";

      // Compatibility with legacy values like "fa-solid fa-gear" or "fa-gear"
      if (rawIcon.includes("fa-")) {
        const faToken = rawIcon
          .split(" ")
          .find((token) => token.startsWith("fa-") && token !== "fa-solid" && token !== "fa-regular" && token !== "fa-brands");
        if (faToken) return faToken.replace(/^fa-/, "");
      }

      return rawIcon;
    },
  },
  computed: {
    logoSrc() {
      const fallback = imageContext("./logo-login.png");
      if (!this.icono) return fallback;
      const candidates = [this.icono, `${this.icono}.png`, `${this.icono}.jpg`, `${this.icono}.jpeg`];
      for (const file of candidates) {
        try {
          return imageContext(`./${file}`);
        } catch (e) {
          // keep trying
        }
      }
      return fallback;
    },
    role() {
      // console.log(this.$store.state.userRole) 
      return this.$store.state?.userRole; 
    },
    isAuthenticated() {
      // console.log(this.$store.state.isAuthenticated) 
      return this.$store.state?.isAuthenticated; 
    },
    language() {
      // console.log(this.$store.state._language) 
      return this.$store.state?._language; 
    },
    labels() {
      if (this.$store.state._language == "es-ES") { 
        return {
          pages: [
            {
              name: "Dashboard",
              ref: "/home",
              route: "home",
              roles: [],
              icon: "fa-solid fa-house",
            },
            {
              name: "Administrador",
              ref: "/administrador",
              route: "administrador",
              roles: [],
              icon: "lock",
            },
            {
              name: "Parametrización",
              ref: "/parametrizacion",
              route: "parametrizacion",
              roles: [],
              icon: "layer-group",
            },
            {
              name: "Cargues",
              ref: "/cargue",
              route: "cargue",
              roles: [],
              icon: "upload",
            },
            {
              name: "Consolidación",
              ref: "/consolidation",
              route: "consolidation",
              roles: [],
              icon: "list",
            },
            // {
            //   name: "Usuarios",
            //   ref: "/users",
            //   route: "users",
            //   roles: [1],
            //   icon: "users",
            // },
            // {
            //   name: "Monedas",
            //   ref: "/currency",
            //   route: "currency",
            //   roles: [1],
            //   icon: "coins",
            // },
            // {
            //   name: "Tasas Cambio",
            //   ref: "/tasaCambio",
            //   route: "tasaCambio",
            //   roles: [1],
            //   icon: "people-arrows",
            // },
            // {
            //   name: "Compañias",
            //   ref: "/company",
            //   route: "company",
            //   roles: [1],
            //   icon: "building",
            // },
            // {
            //   name: "Esquemas",
            //   ref: "/planConsolidacion",
            //   route: "planConsolidacion",
            //   roles: [1],
            //   icon: "list",
            // },
            // {
            //   name: "Niif",
            //   ref: "/niif",
            //   route: "niif",
            //   roles: [1],
            //   icon: "bars",
            // },
            // {
            //   name: "Plan cuentas",
            //   ref: "/planCuentas",
            //   route: "planCuentas",
            //   roles: [1],
            //   icon: "list",
            // },
            /*{
              name: "Balance Niif",
              ref: "/balanceNiif",
              route: "balanceNiif",
              roles: [1],
              icon: "list",
            },
            {
              name: "ESF",
              ref: "/reporteEsf",
              route: "reporteEsf",
              roles: [1],
              icon: "list",
            },
            {
              name: "ERI",
              ref: "/reporteEri",
              route: "reporteEri",
              roles: [1],
              icon: "list",
            },
            {
              name: "EFE",
              ref: "/reporteEfe",
              route: "reporteEfe",
              roles: [1],
              icon: "list",
            },
            {
              name: "ECP",
              ref: "/reporteEcp",
              route: "reporteEcp",
              roles: [1],
              icon: "list",
            },
            {
              name: "Indicadores",
              ref: "/reporteIndicadores",
              route: "reporteIndicadores",
              roles: [1],
              icon: "list",
            },*/
          ],
        };
      } else {
        return {
          pages: [
            {
              name: "Dashboard",
              ref: "/home",
              route: "home",
              roles: [1],
              icon: "fa-solid fa-house",
            },
            {
              name: "Administrator",
              ref: "/administrador",
              route: "administrador",
              roles: [1],
              icon: "lock",
            },
            {
              name: "Parametrización",
              ref: "/parametrizacion",
              route: "parametrizacion",
              roles: [1],
              icon: "layer-group",
            },
            {
              name: "Charge",
              ref: "/cargue",
              route: "cargue",
              roles: [1],
              icon: "upload",
            },
            {
              name: "Consolidation",
              ref: "/consolidation",
              route: "consolidation",
              roles: [1],
              icon: "list",
            },
            // {
            //   name: "Users",
            //   ref: "/users",
            //   route: "users",
            //   roles: [1],
            //   icon: "users",
            // },
            // {
            //   name: "Currency",
            //   ref: "/currency",
            //   route: "currency",
            //   roles: [1],
            //   icon: "coins",
            // },
            // {
            //   name: "Exchange rate",
            //   ref: "/tasaCambio",
            //   route: "tasaCambio",
            //   roles: [1],
            //   icon: "people-arrows",
            // },
            // {
            //   name: "Company",
            //   ref: "/company",
            //   route: "company",
            //   roles: [1],
            //   icon: "building",
            // },
            // {
            //   name: "Schedule",
            //   ref: "/planConsolidacion",
            //   route: "planConsolidacion",
            //   roles: [1],
            //   icon: "list",
            // },
            // {
            //   name: "Niif",
            //   ref: "/niif",
            //   route: "niif",
            //   roles: [1],
            //   icon: "bars",
            // },
            // {
            //   name: "Chart accounts",
            //   ref: "/planCuentas",
            //   route: "planCuentas",
            //   roles: [1],
            //   icon: "list",
            // },
            // {
            //   name: "NIIF",
            //   ref: "/balanceNiif",
            //   route: "balanceNiif",
            //   roles: [1],
            //   icon: "list",
            // },
            /*{
              name: "ESF",
              ref: "/reporteEsf",
              route: "reporteEsf",
              roles: [1],
              icon: "list",
            },
            {
              name: "ERI",
              ref: "/reporteEri",
              route: "reporteEri",
              roles: [1],
              icon: "list",
            },
            {
              name: "EFE",
              ref: "/reporteEfe",
              route: "reporteEfe",
              roles: [1],
              icon: "list",
            },
            {
              name: "ECP",
              ref: "/reporteEcp",
              route: "reporteEcp",
              roles: [1],
              icon: "list",
            },
            {
              name: "Indicadores",
              ref: "/reporteIndicadores",
              route: "reporteIndicadores",
              roles: [1],
              icon: "list",
            },*/
          ],
        };
      }
    },
    pages() {
// console.log("State ",this.$store.state) 
      // return this.labels.pages?.filter((page) => { 
      return this.newMenu?.filter((page) => { 
        if ((page.route || "").toLowerCase() === "home") return true;
        return page.roles?.find((item) => { 
          return item == this.$store.state?.userRole; 
        });
      });
    },
  },
  mounted(){
    Authentication.leaParametros() 
    .then((result) => { 
      this.icono = result.data.parametros.icono 
      this.compania = result.data.parametros.compania 
    })
    .catch((err) => console.log(err))

    Menu.getAllMenu() 
    .then((res) => { 
      // console.log(res.data.listMenu) 
      this.listMenu = res.data.listMenu 
      // console.log(this.listMenu) 
      this.listMenu.forEach((elem) => { 
        // console.log(elem.roles.split(',')) 
        let rol = elem.roles.split(',') 
        // console.log(rol) 
        let asigRol = rol.filter((rol) => rol == this.$store.state.userRole)
        if ((elem.ruta || "").toLowerCase() === "home") {
          asigRol = [String(this.$store.state.userRole)];
        }
        // console.log(asigRol) 
        
        let objMenu = {
          'name' : elem.nombre, 
          'ref' : elem.referencia, 
          'route' : elem.ruta, 
          'roles' : asigRol,
          'icon' : elem.icono 
        }
        this.newMenu.push(objMenu) 
      })
      // console.log(this.newMenu) 
    })
    .catch((err) => { 
      console.log(err) 
    })
  },
};
</script>

<style>
/* d-none d-md-flex */
#sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 80px;
  background: var(--five);
  transition: 0.3s width ease; 
  z-index: 1200;
  padding: 20px;
  overflow-x: hidden;
}
#sidebar ul {
  list-style: none;
  padding: 0;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 18px;
}
.sidebar-logo-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 54px;
  margin-bottom: 16px;
}
.sidebar-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 0;
}
.sidebar-logo {
  max-height: 50px;
  width: auto;
  object-fit: contain;
  -webkit-filter: brightness(0) invert(1) !important;
  filter: brightness(0) invert(1) !important;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}
#sidebar:hover .sidebar-logo-item {
  padding-left: 0 !important;
}
#sidebar:hover .sidebar-logo {
  opacity: 1;
}
#sidebar ul li.sidebar-logo-item:hover {
  padding-left: 0 !important;
  background: transparent !important;
}
#sidebar ul li {
  width: 100%;
  border-radius: 6px;
  transition: all 0.3s ease; 
  margin: 5px 0;
  overflow: hidden;
}
#sidebar:hover ul li {
  padding-left: 12px;
}
#sidebar ul li.active-page { 
  background: var(--second);
  padding: auto;
  min-width: 40px;
  max-width: 200px;
}
/* #sidebar ul li.active-page svg{ 
  color: #ff924c;
} */
#sidebar ul li.active-page a i{ 
  color: #ff924c;
}
#sidebar ul li.active-page span{ 
  color: var(--five);
}
#sidebar ul li:hover {
  padding-left: 16px;
  background: rgba(255, 255, 255, 0.5); 
}
#sidebar ul li a {
  display: flex;
  align-items: center;
  justify-content: center; /* cerrado */
  height: 40px;
  color: var(--second) !important;
  text-decoration: none;
  font-size: 0.95rem; 
}

#sidebar ul li a i {
  width: 24px;
  text-align: center;
  font-size: 18px;
  flex-shrink: 0;
}

#sidebar:hover ul li a {
  justify-content: flex-start;
}

#sidebar ul li a span {
  display: none;
  margin-left: 1rem;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 155px;
}

#sidebar ul li svg {
  height: 40px;
  width: 40px;
  padding: 8px;
  border-radius: 6px;
  font-size: 2rem;
  color: var(--icon);
}
#sidebar:hover {
  width: 250px;
  
}

#sidebar:hover span {
  display: block;
}


#sidebar ul li a,
#sidebar ul li a:focus,
#sidebar ul li a:active,
#sidebar ul li a:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

/* Small screens */
@media (max-width: 575.98px) { 
  #sidebar {
    top: auto;
    bottom: 0;
    min-width: 100%;
    width: 100%;
    height: 3rem;
    overflow: hidden;
  }
  #sidebar ul {
    flex-direction: row;
    justify-content: center;
  }
  #sidebar ul li:first-child {
    display: none;
  }
  #sidebar:hover ul li {
    padding-left: 0px;
  }
  #sidebar ul li:hover {
    padding-left: 0px;
    background: var(--seven);
  }
  #sidebar:hover {
    min-width: 100%;
  }

  #sidebar:hover span {
    display: none;
  }
  #sidebar ul li a {
    justify-content: center;
  }
}
</style>
